import { render, staticRenderFns } from "./PenyebranganAdd.vue?vue&type=template&id=64c83e22&scoped=true"
import script from "./PenyebranganAdd.vue?vue&type=script&lang=js"
export * from "./PenyebranganAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c83e22",
  null
  
)

export default component.exports